<template>
  <!-- An item in an activity entry: its kind and name, linking to its page while it exists (US 9438) -->
  <router-link v-if="item.to && !isHere"
               :to="item.to"
               class="ae-item ae-item--link"
               data-qid="activity-item">
    <font-awesome-icon :icon="item.icon"/><span v-if="item.type" class="ae-item__type">{{ item.type }}</span>{{ item.name }}
  </router-link>
  <a v-else-if="item.download"
     href="#"
     class="ae-item ae-item--link"
     @click.prevent="download"
     data-qid="activity-item-download">
    <font-awesome-icon :icon="item.icon"/><span v-if="item.type" class="ae-item__type">{{ item.type }}</span>{{ item.name }}
  </a>
  <span v-else class="ae-item" data-qid="activity-item">
    <font-awesome-icon :icon="item.icon"/><span v-if="item.type" class="ae-item__type">{{ item.type }}</span>{{ item.name }}
  </span>
</template>

<script>
import piincHttp from '@/util/configureAxios.js';

export default {
  name: 'ActivityItemChip',
  props: {
    item: {
      type: Object,
      required: true
    },
    // { kind, slug } of the page the list is on
    here: {
      type: Object,
      default: null
    }
  },
  computed: {
    isHere() {
      return !!this.here && this.here.kind === this.item.kind && this.here.slug === this.item.slug;
    }
  },
  methods: {
    // An imported audit plan can be downloaded again (US 9404)
    download() {
      const file = this.item.download;
      piincHttp.get('documents/' + file.id + '/download', { responseType: 'blob' }).then(response => {
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(new Blob([response.data]));
        link.download = file.name;
        document.body.appendChild(link);
        link.click();
        link.remove();
      }, () => {
        this.$toastr('error', this.$t('template_view.history.download_failed'));
      });
    }
  }
};
</script>
